import { FC } from 'react'

const Country: FC<{ country?: string | null; height?: number }> = ({ country, height = 22 }) => {
  if (!country) return null
  return (
    <img
      alt={country}
      height={height}
      width={height * 1.5}
      src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${country.toUpperCase()}.svg`}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
    />
  )
}

export { Country }
